(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anissa-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQuiz(root) {
      if (!root || root.dataset.aqReady) return;
      root.dataset.aqReady = '1';
      var order = ['start', 'thema', 'info', 'probiert', 'zeit', 'laden', 'auswertung', 'ergebnis', 'upsell'];
      var st = { area: null, areaLabel: '', thema: null, probiert: null, zeit: null, zeitLabel: '', result: null, override: null, hist: [], timer: null, started: false };
      var screens = root.querySelectorAll('[data-screen]');
      var backBtn = root.querySelector('[data-back]');
      var bar = root.querySelector('[data-progress]');

      function track(name, data) {
        try { if (window.fbq) window.fbq('trackCustom', name, data || {}); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('anissa_' + name, data || {}); } catch (e) {}
      }

      function show(name, noHist) {
        var cur = root.querySelector('[data-screen]:not([hidden])');
        var curName = cur ? cur.getAttribute('data-screen') : null;
        if (!noHist && curName && curName !== name && curName !== 'laden') st.hist.push(curName);
        screens.forEach(function (s) { s.hidden = s.getAttribute('data-screen') !== name; });
        var i = order.indexOf(name);
        if (bar) bar.style.width = Math.round(((i + 1) / order.length) * 100) + '%';
        if (backBtn) backBtn.hidden = !(st.hist.length > 0 && name !== 'laden');
        var top = root.getBoundingClientRect().top + window.pageYOffset;
        if (window.pageYOffset > top) window.scrollTo(0, top);
      }

      function selectIn(container, el) {
        container.querySelectorAll('.is-sel').forEach(function (x) { x.classList.remove('is-sel'); });
        if (el) el.classList.add('is-sel');
      }

      function filterThemen(area) {
        var grid = root.querySelector('[data-thema-grid]');
        var tiles = grid.querySelectorAll('[data-pick-thema]');
        var vis = [];
        tiles.forEach(function (t) {
          var on = t.getAttribute('data-area') === area;
          t.hidden = !on;
          t.classList.remove('aq__tile--wide-js');
          if (on) vis.push(t);
        });
        if (vis.length % 2 === 1) vis[vis.length - 1].classList.add('aq__tile--wide-js');
      }

      function resultKey() {
        if (st.override) return st.override;
        if (!st.thema) return null;
        var shortKey = st.thema.getAttribute('data-result-short');
        if (st.zeit === 'kurz' && shortKey) return shortKey;
        return st.thema.getAttribute('data-result');
      }

      function showResult(key, isAlt) {
        var panels = root.querySelectorAll('[data-result]');
        var found = null;
        panels.forEach(function (p) { if (p.getAttribute('data-result') === key) found = p; });
        if (!found && panels.length) found = panels[0];
        panels.forEach(function (p) { p.hidden = p !== found; });
        if (!found) return;
        st.result = found;
        var k = found.querySelector('[data-kicker-el]');
        if (k) k.textContent = isAlt ? root.getAttribute('data-kicker-alt') : root.getAttribute('data-kicker');
        var note = found.querySelector('[data-note-el]');
        var noteTxt = st.probiert ? st.probiert.getAttribute('data-note') : '';
        if (note) { note.textContent = noteTxt; note.hidden = isAlt || !noteTxt; }
        var tip = found.querySelector('[data-tip-el]');
        if (tip) tip.textContent = st.zeit === 'kurz' ? root.getAttribute('data-tip-kurz') : (st.zeit === 'ritual' ? root.getAttribute('data-tip-ritual') : '');
        show('ergebnis');
        track('QuizErgebnis', { ergebnis: found.getAttribute('data-result'), produkt: found.getAttribute('data-name') });
      }

      function goCheckout(withUp) {
        if (!st.result) return;
        var vid = st.result.getAttribute('data-vid');
        if (!vid) return;
        var items = vid + ':1';
        var upvid = st.result.getAttribute('data-upvid');
        if (withUp && upvid) items += ',' + upvid + ':1';
        var url = root.getAttribute('data-cart-url') + '/' + items;
        var code = root.getAttribute('data-discount');
        if (code) url += '?discount=' + encodeURIComponent(code);
        track('QuizCheckout', { ergebnis: st.result.getAttribute('data-result'), upsell: !!(withUp && upvid) });
        window.location.href = url;
      }

      root.addEventListener('click', function (ev) {
        var t = ev.target.closest('button, a');
        if (!t || !root.contains(t)) return;

        if (t.hasAttribute('data-back')) {
          if (st.timer) { clearTimeout(st.timer); st.timer = null; }
          var curScr = root.querySelector('[data-screen]:not([hidden])');
          if (st.override && curScr && curScr.getAttribute('data-screen') === 'ergebnis') { st.override = null; showResult(resultKey(), false); return; }
          var prev = st.hist.pop();
          if (prev) { if (prev === 'ergebnis') { st.override = null; } show(prev, true); }
          return;
        }
        if (t.hasAttribute('data-pick-area')) {
          if (!st.started) { st.started = true; track('QuizStart', {}); }
          st.area = t.getAttribute('data-pick-area');
          st.areaLabel = t.getAttribute('data-label');
          st.override = null;
          selectIn(t.parentNode, t);
          root.querySelector('[data-q2-title]').textContent = t.getAttribute('data-q2');
          filterThemen(st.area);
          show('thema');
          return;
        }
        if (t.hasAttribute('data-pick-thema')) {
          st.thema = t;
          st.override = null;
          selectIn(t.parentNode, t);
          var key = t.getAttribute('data-has-info') ? 'thema-' + t.getAttribute('data-pick-thema') : 'area-' + st.area;
          var any = false;
          root.querySelectorAll('[data-info]').forEach(function (inf) { var on = inf.getAttribute('data-info') === key; inf.hidden = !on; if (on) any = true; });
          show(any ? 'info' : 'probiert');
          return;
        }
        if (t.hasAttribute('data-next')) { show(t.getAttribute('data-next')); return; }
        if (t.hasAttribute('data-pick-probiert')) {
          st.probiert = t;
          selectIn(t.parentNode, t);
          show('zeit');
          return;
        }
        if (t.hasAttribute('data-pick-zeit')) {
          st.zeit = t.getAttribute('data-pick-zeit');
          st.zeitLabel = t.getAttribute('data-label');
          selectIn(t.parentNode, t);
          root.querySelector('[data-sum="area"]').textContent = st.areaLabel || '–';
          root.querySelector('[data-sum="thema"]').textContent = st.thema ? st.thema.getAttribute('data-label') : '–';
          root.querySelector('[data-sum="probiert"]').textContent = st.probiert ? st.probiert.getAttribute('data-label') : '–';
          root.querySelector('[data-sum="zeit"]').textContent = st.zeitLabel || '–';
          root.classList.remove('is-loading');
          void root.offsetWidth;
          root.classList.add('is-loading');
          show('laden');
          if (st.timer) clearTimeout(st.timer);
          st.timer = setTimeout(function () { st.timer = null; show('auswertung', true); }, 2900);
          return;
        }
        if (t.hasAttribute('data-show-result')) { st.override = null; showResult(resultKey(), false); return; }
        if (t.hasAttribute('data-alt')) { st.override = t.getAttribute('data-alt'); showResult(st.override, true); return; }
        if (t.hasAttribute('data-order')) {
          var rk = st.result ? st.result.getAttribute('data-result') : '';
          var upEl = null;
          root.querySelectorAll('[data-up-for]').forEach(function (u) { var on = u.getAttribute('data-up-for') === rk; u.hidden = !on; if (on) upEl = u; });
          if (upEl && st.result.getAttribute('data-upvid')) { show('upsell'); } else { goCheckout(false); }
          return;
        }
        if (t.hasAttribute('data-checkout')) { goCheckout(t.getAttribute('data-checkout') === 'mit'); return; }
      });

      root.__aqShowBlock = function (blockId) {
        var el = root.querySelector('[data-block="' + blockId + '"]');
        if (!el) return;
        if (el.hasAttribute('data-pick-thema')) {
          st.area = el.getAttribute('data-area');
          filterThemen(st.area);
          var a = root.querySelector('[data-pick-area="' + st.area + '"]');
          root.querySelector('[data-q2-title]').textContent = a ? a.getAttribute('data-q2') : '';
        }
        if (el.hasAttribute('data-result')) {
          root.querySelectorAll('[data-result]').forEach(function (p) { p.hidden = p !== el; });
          st.result = el;
        }
        var scr = el.closest('[data-screen]');
        if (scr) show(scr.getAttribute('data-screen'), true);
      };

      show('start', true);
    }

    function initAll(scope) { (scope || document).querySelectorAll('.aq').forEach(initQuiz); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest ? e.target.closest('.aq') : null;
      if (root && root.__aqShowBlock) root.__aqShowBlock(e.detail.blockId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pflegefinder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFinder(root) {
      if (!root || root.dataset.pfReady) return;
      root.dataset.pfReady = '1';

      var st = { step: 'start', hist: [], areas: [], needs: {}, picks: {}, timer: null, started: false };
      var screens = root.querySelectorAll('[data-screen]');

      function $(sel, scope) { return (scope || root).querySelector(sel); }
      function $$(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
      function track(name, data) {
        try { if (window.fbq) window.fbq('trackCustom', name, data || {}); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('anissa_' + name, data || {}); } catch (e) {}
      }
      function hasScreen(name) { return !!root.querySelector('[data-screen="' + name + '"]'); }

      function stepList() {
        var list = [];
        if (hasScreen('bereich')) list.push('bereich');
        st.areas.forEach(function (a) { if (hasScreen('need-' + a.key)) list.push('need-' + a.key); });
        var needHaut = st.areas.some(function (a) { return a.hauttyp; });
        if (needHaut && hasScreen('hauttyp')) list.push('hauttyp');
        ['empfindlich', 'alter', 'probiert', 'zeit'].forEach(function (s) { if (hasScreen(s)) list.push(s); });
        return list;
      }

      function show(name, noHist) {
        if (!noHist && st.step && st.step !== name && st.step !== 'laden') st.hist.push(st.step);
        st.step = name;
        screens.forEach(function (s) { s.hidden = s.getAttribute('data-screen') !== name; });
        var cur = root.querySelector('[data-screen="' + name + '"]');
        var list = stepList();
        var i = list.indexOf(name);
        if (cur && i >= 0) {
          var c = $('[data-count]', cur); if (c) c.textContent = 'Schritt ' + (i + 1) + ' von ' + list.length;
          var segs = $('[data-segs]', cur);
          if (segs) {
            segs.innerHTML = '';
            list.forEach(function (x, k) { var sp = document.createElement('span'); if (k < i) sp.className = 'is-done'; if (k === i) sp.className = 'is-now'; segs.appendChild(sp); });
          }
        }
        var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
        if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }

      function nextFrom(name) {
        var list = stepList();
        var i = list.indexOf(name);
        var nx = list[i + 1];
        if (nx) { show(nx); return; }
        root.classList.remove('is-loading'); void root.offsetWidth; root.classList.add('is-loading');
        show('laden');
        if (st.timer) clearTimeout(st.timer);
        st.timer = setTimeout(function () { st.timer = null; showResult(); }, 2900);
      }

      function pressOnly(btn) {
        $$('[aria-pressed]', btn.parentNode).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
      }

      function keyFor(need) {
        var p = st.picks;
        var sens = p.empfindlich && p.empfindlich.merkmal === 'sensibel';
        var kurz = p.zeit && p.zeit.value === 'kurz';
        var k = need.getAttribute('data-result');
        if (sens && need.getAttribute('data-result-sens')) k = need.getAttribute('data-result-sens');
        else if (kurz && need.getAttribute('data-result-short')) k = need.getAttribute('data-result-short');
        return k;
      }

      function setAreaLabel(el, label) { $$('[data-for-area]', el).forEach(function (x) { x.textContent = label ? 'Für: ' + label : ''; }); }

      function showResult() {
        var picks = st.picks;
        var keys = [];
        st.areas.forEach(function (a) {
          var nd = st.needs[a.key];
          if (!nd) return;
          var k = keyFor(nd);
          if (k && !keys.some(function (x) { return x.k === k; })) keys.push({ k: k, label: a.label });
        });
        $$('[data-main]').forEach(function (m) { m.hidden = true; });
        $$('[data-mini]').forEach(function (m) { m.hidden = true; });
        var main = null;
        if (keys.length) main = root.querySelector('[data-main="' + keys[0].k + '"]');
        if (!main) main = root.querySelector('[data-main]');
        if (main) { main.hidden = false; setAreaLabel(main, keys[0] ? keys[0].label : ''); }

        var moreCount = 0;
        keys.slice(1).forEach(function (x) {
          var mi = root.querySelector('[data-mini="' + x.k + '"]');
          if (mi) { mi.hidden = false; setAreaLabel(mi, x.label); moreCount++; }
        });
        var kombi = root.getAttribute('data-kombi');
        var combo = $('[data-combo]');
        var showCombo = combo && st.areas.length > 1 && !keys.some(function (x) { return x.k === kombi; });
        if (combo) combo.hidden = !showCombo;
        var wrap = $('[data-more-wrap]');
        if (wrap) wrap.hidden = !(moreCount || showCombo);

        var chips = $('[data-chips]');
        if (chips) {
          chips.innerHTML = '';
          var labels = [];
          st.areas.forEach(function (a) { if (st.needs[a.key]) labels.push(st.needs[a.key].getAttribute('data-label')); });
          if (picks.hauttyp) labels.push(picks.hauttyp.label);
          if (picks.empfindlich) labels.push(picks.empfindlich.label);
          if (picks.alter) labels.push(picks.alter.label + ' Jahre');
          if (picks.zeit) labels.push(picks.zeit.label);
          labels.forEach(function (l) { var sp = document.createElement('span'); sp.textContent = l; chips.appendChild(sp); });
        }

        if (main) {
          var an = $('[data-analysis]', main);
          if (an) {
            an.innerHTML = '';
            var texts = [];
            var reif = picks.alter && picks.alter.merkmal === 'reif';
            texts.push(root.getAttribute(reif ? 'data-an-reif' : 'data-an-jung'));
            if (picks.empfindlich && picks.empfindlich.merkmal === 'sensibel') texts.push(root.getAttribute('data-an-sensibel'));
            st.areas.forEach(function (a) { var nd = st.needs[a.key]; if (nd && nd.getAttribute('data-info')) texts.push(nd.getAttribute('data-info')); });
            if (picks.probiert && picks.probiert.note) texts.push(picks.probiert.note);
            texts.forEach(function (t) { if (!t) return; var p = document.createElement('p'); p.textContent = t; an.appendChild(p); });
          }
          var tip = $('[data-tip]', main);
          if (tip) {
            var z = picks.zeit ? picks.zeit.value : 'mittel';
            tip.textContent = root.getAttribute(z === 'kurz' ? 'data-tip-kurz' : (z === 'ritual' ? 'data-tip-ritual' : 'data-tip-mittel')) || '';
          }
        }
        var note = root.querySelector('[data-note-field]');
        if (note) note.value = 'Pflegefinder: ' + keys.map(function (x) { return x.k; }).join(', ');
        show('ergebnis');
        track('PflegefinderErgebnis', { ergebnis: keys.map(function (x) { return x.k; }).join(',') });
      }

      function addToCart(btn) {
        if (btn.classList.contains('is-added') || btn.disabled) return;
        var id = btn.getAttribute('data-add');
        btn.disabled = true;
        fetch(root.getAttribute('data-cart-add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }).then(function () {
          btn.disabled = false;
          btn.classList.add('is-added');
          if (btn.classList.contains('pf__round')) btn.textContent = '\u2713'; else btn.textContent = 'Im Warenkorb \u2713';
          var toast = $('[data-toast]');
          if (toast) {
            $('[data-toast-text]', toast).textContent = (btn.getAttribute('data-name') || 'Produkt') + ' liegt im Warenkorb.';
            toast.hidden = false;
            clearTimeout(st.toastT); st.toastT = setTimeout(function () { toast.hidden = true; }, 5000);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          track('PflegefinderWarenkorb', { produkt: btn.getAttribute('data-name') });
        }).catch(function () {
          btn.disabled = false;
          window.location.href = root.getAttribute('data-cart-url');
        });
      }

      root.addEventListener('click', function (ev) {
        var t = ev.target.closest('button');
        if (!t || !root.contains(t)) return;

        if (t.hasAttribute('data-begin')) { if (!st.started) { st.started = true; track('PflegefinderStart', {}); } show('bereich'); return; }
        if (t.hasAttribute('data-back')) {
          if (st.timer) { clearTimeout(st.timer); st.timer = null; }
          var prev = st.hist.pop();
          if (prev) show(prev, true);
          return;
        }
        if (t.hasAttribute('data-area')) {
          var on = t.getAttribute('aria-pressed') !== 'true';
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
          st.areas = $$('[data-area][aria-pressed="true"]').map(function (b) { return { key: b.getAttribute('data-area'), label: b.getAttribute('data-label'), hauttyp: !!b.getAttribute('data-hauttyp') }; });
          var nb = $('[data-area-next]'); if (nb) nb.disabled = st.areas.length === 0;
          var hint = $('[data-area-hint]');
          if (hint) hint.textContent = st.areas.length ? st.areas.length + ' gewählt' : 'Du kannst mehrere Bereiche wählen.';
          return;
        }
        if (t.hasAttribute('data-area-next')) { if (st.areas.length) nextFrom('bereich'); return; }
        if (t.hasAttribute('data-pick')) {
          pressOnly(t);
          var kind = t.getAttribute('data-pick');
          if (kind === 'need') {
            st.needs[t.getAttribute('data-area-key')] = t;
            nextFrom('need-' + t.getAttribute('data-area-key'));
          } else {
            st.picks[kind] = { value: t.getAttribute('data-value'), label: t.getAttribute('data-label'), merkmal: t.getAttribute('data-merkmal') || '', note: t.getAttribute('data-note') || '' };
            nextFrom(kind);
          }
          return;
        }
        if (t.hasAttribute('data-add')) { addToCart(t); return; }
        if (t.hasAttribute('data-restart')) {
          st.hist = []; st.areas = []; st.needs = {}; st.picks = {};
          $$('[aria-pressed]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          var nb2 = $('[data-area-next]'); if (nb2) nb2.disabled = true;
          show('start', true);
          return;
        }
      });

      root.__pfShowBlock = function (blockId) {
        var el = root.querySelector('[data-block="' + blockId + '"]');
        if (!el) return;
        if (el.hasAttribute('data-main')) { $$('[data-main]').forEach(function (m) { m.hidden = m !== el; }); }
        var scr = el.hasAttribute('data-screen') ? el : el.closest('[data-screen]');
        if (scr) show(scr.getAttribute('data-screen'), true);
      };

      if (/[?&]contact_posted=true/.test(window.location.search) || window.location.hash === '#pf-mail-form') {
        show('ergebnis', true);
        var first = root.querySelector('[data-main]'); if (first) first.hidden = false;
      } else {
        show('start', true);
      }
    }

    function initAll(scope) { (scope || document).querySelectorAll('.pf').forEach(initFinder); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest ? e.target.closest('.pf') : null;
      if (root && root.__pfShowBlock) root.__pfShowBlock(e.detail.blockId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPresale(root) {
      if (!root || root.dataset.psReady) return;
      root.dataset.psReady = '1';
      var form = root.querySelector('[data-ps-form]');
      var success = root.querySelector('[data-ps-success]');
      if (!form) return;
      var mail = form.querySelector('input[name="EMAIL"]');
      var err = form.querySelector('.ps__err');
      var btn = form.querySelector('[data-ps-submit]');
      var optin = form.querySelector('[data-ps-optin]');
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      function showErr(on) { err.hidden = !on; mail.setAttribute('aria-invalid', on ? 'true' : 'false'); }
      mail.addEventListener('input', function () { showErr(false); });

      function done() {
        form.hidden = true;
        success.hidden = false;
        try { if (window.fbq) window.fbq('track', 'Lead', { content_name: 'Black Week Pre Sale' }); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('anissa_presale_anmeldung', {}); } catch (e) {}
      }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!re.test(mail.value.trim())) { showErr(true); mail.focus(); return; }
        if (optin && !optin.checked) { optin.focus(); optin.reportValidity && optin.reportValidity(); return; }
        var action = form.getAttribute('action');
        if (!action) { err.textContent = 'Die Anmeldung ist gerade nicht möglich. Bitte versuche es später noch einmal.'; err.hidden = false; return; }
        btn.disabled = true;
        var url = action + (action.indexOf('?') >= 0 ? '&' : '?') + 'isAjax=1';
        fetch(url, { method: 'POST', body: new FormData(form), mode: 'no-cors' })
          .then(function () { done(); })
          .catch(function () { form.submit(); done(); })
          .finally(function () { btn.disabled = false; });
      });

      root.querySelectorAll('[data-ps-jump]').forEach(function (b) {
        b.addEventListener('click', function () {
          var target = success && !success.hidden ? success : mail;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (target === mail) setTimeout(function () { mail.focus({ preventScroll: true }); }, 400);
        });
      });
    }
    function initAll(scope) { (scope || document).querySelectorAll('.ps').forEach(initPresale); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
